import React from 'react';
import PropTypes from 'prop-types';

import DateFilter from '../../../../common/DatePickerV2';
import ExportCsvButton from '../../filters/ExportCsvButton';
import { getToday } from '../../../../common/RangeFilter/helpers';

const TimeTrackingFilter = ({
  startDate,
  endDate,
  onDateChange,
  canInstantDownloadCsv,
  downloadCsv,
  timezone,
}) => (
  <div className="c-form-input-group c-form-input-group--bottom u-mb s-v2">
    <div className="c-report-filters">
      <div className="c-report-filters__item">
        <DateFilter
          range
          endDate={getToday(timezone)}
          onChange={onDateChange}
          from={startDate}
          to={endDate}
        />
      </div>
      <ExportCsvButton
        className="u-ml0"
        csv={downloadCsv}
        disabled={!canInstantDownloadCsv}
      />
    </div>
  </div>
);

TimeTrackingFilter.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  onDateChange: PropTypes.func.isRequired,
  canInstantDownloadCsv: PropTypes.bool.isRequired,
  downloadCsv: PropTypes.func.isRequired,
  timezone: PropTypes.string.isRequired,
};

export default TimeTrackingFilter;
